import HeaderSearchButtons from "@pages/dvtjcuv/rundvtjcuv/HeaderSearchButtons";
import React, { useEffect, useState } from "react";
import CddSddvContent from "@pages/dvtjcuv/list/cddsddv/CddSddvContent";
import { DVTJCUVCddSddvParentTabs } from "@pages/dvtjcuv/common/CddSddvTabs";

const CddSddvManager = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [currentParentTab, setCurrentParentTab] = useState(DVTJCUVCddSddvParentTabs.USDING_SDDV_TAB);
    const [runJobInfo, setRunJobInfo] = useState({
        email_tab: {}
    });

    const {runJob} = props;

    const hash = window.location.hash.substring(1);

    useEffect(() => {
        if (runJob) {
            setRunJobInfo({...runJob});
        }
    }, [runJob]);

    useEffect(() => {
        Object.values(DVTJCUVCddSddvParentTabs).forEach(tab => {
            if (hash && hash === tab.id) {
                setCurrentParentTab(tab);
            }
        });
    }, []);

    const activeTab = (tab) => {
        if (currentParentTab.id === tab.id) {
            return 'active';
        }
        return '';
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">LIST CDD SDDV</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                {/* <div className="card-tools pr-2 col-6">
                    <HeaderSearchButtons
                        showBtnSearchPipeline
                        showBtnSearchCdd
                        showBtnSearchReceiver
                        showBtnSearchEmployer
                    />
                </div> */}
            </div>
            <div className="card-body">
                <ul className='nav nav-tabs' role='tablist'>
                    {Object.values(DVTJCUVCddSddvParentTabs).map(tab => (
                        <li className='nav-item' key={tab.id}>
                            <a className={`nav-link ${activeTab(tab)}`} 
                               data-toggle='tab' 
                               href={`#${tab.id}`}
                               onClick={() => {
                                   setCurrentParentTab(tab);
                                   window.location.hash = tab.id;
                               }}>
                                {tab.title}
                            </a>
                        </li>
                    ))}
                </ul>
                <div className='tab-content'>
                    {Object.values(DVTJCUVCddSddvParentTabs).map((tab) => {
                        if (currentParentTab.id === tab.id) {
                            return (
                                <div id={tab.id} className={`tab-pane active`} key={tab.id}>
                                    <CddSddvContent 
                                        data={runJobInfo} 
                                        parentTab={tab}
                                    />
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    );
};

export default CddSddvManager; 